<template>
  <SettingsField :label="label || $t('platform.create.name')" :hint="$t('platform.card.fields.name')" :error="error" :labelFor="id">
    <div class="form-item__field">
      <input :id="id" ref="input" type="text" :value="value" :class="{ invalid: !!error }" @input="$emit('input', $event.target.value)" @change="$emit('input', $event.target.value.trim())" />
    </div>
  </SettingsField>
</template>
<script>
import SettingsField from "@/components/PlatformCard/SettingsField.vue";

let uid = 0;

export default {
  name: "NameField",
  components: { SettingsField },
  props: {
    value: {
      type: String,
      default: "",
    },
    // vuelidate state of the name: required, minLength(3), maxLength(52)
    v: {
      type: Object,
      default: null,
    },
    label: {
      type: String,
      default: "",
    },
  },
  data() {
    return { id: `platform-name-${++uid}` };
  },
  computed: {
    error() {
      if (!this.v) return "";
      if (!this.v.maxLength) return this.$t("max_len_pass", { number: 52 });
      if ((this.v.$dirty || this.value) && (!this.v.minLength || !this.v.required)) return this.$t("min_len_pass", { number: "3" });
      return "";
    },
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    },
  },
};
</script>
